<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto sm:flex sm:justify-between">
        <input v-model="query.keyword" type="text" name="first-name" placeholder="关键字筛选" autocomplete="given-name" class="mt-1 mr-4 inline-block border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
        <a target="_blank" href="/community/post.html" type="button" class="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-1 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto cursor-pointer">发 帖</a>
      </div>
    </div>
    <div class="mt-4 flex flex-col">
      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
          <div class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
            <table class="min-w-full divide-y divide-gray-300">
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">标题</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">所属分类</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">发布时间</th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">状态</th>
                  <th scope="col" class="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span class="sr-only">操作</span>
                  </th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr v-for="item in tableData" :key="item.Id">
                  <td class="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6"><a :href="'https://www.huoyuyan.com/community/detail.html?id='+item.Id" target="_blank">{{item.Title}}</a></td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500"><a :href="'https://www.huoyuyan.com/community/?PageSize=10&PageIndex=1&CategoryId='+item.CategoryId" target="_blank">{{item.Category.Title}}</a></td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{item.AddTime}}</td>
                  <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                    <span v-if="item.Status === 0" class="text-green-600">正常</span>
                    <span v-else-if="item.Status === 1">待审核</span>
                    <span class="text-red" v-else>未通过</span>
                  </td>
                  <td class="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="查看" @click="viewAction(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4 text-gray-500">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="编辑" @click="editAction(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-4 w-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                      </svg>
                    </a>
                    <a href="javascript:;" class="text-gray-500 hover:text-gray-900 inline-block mr-1" title="删除" @click="deleteItem(item)">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                      </svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Pagination :size="query.PageSize" :page="query.PageIndex" :total="total" @change="changePage" />
    <Alert :visible.sync="alertShow" ref="alert" />
    <Notify ref="notify" />
    <Modal :visible.sync="detailDialog" :title="title" :ActionBtnShow="action !== 'view'" width="max-w-7xl" :fullscreen="fullscreen" @submit="submit()">
      <div class="space-y-6 sm:space-y-0 sm:py-0 my-4 mx-2">
        <!-- {{detail.Content}} -->

        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">所属分类</label>
          </div>
          <div class="sm:col-span-7">
            <template v-if="action === 'view'">{{ getCate(form.CategoryId) }}</template>
            <select v-else v-model="form.CategoryId" name="country" autocomplete="country-name" class="mt-1 mr-4 w-48 inline-block bg-white border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
              <option v-for="item in cateList" :key="item.Id" :value="item.Id" :selected="form.CategoryId === item.Id">{{ item.Title }}</option>
            </select>
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">标题</label>
          </div>
          <div class="sm:col-span-7">
            <template v-if="action === 'view'">{{form.Title}}</template>
            <input v-else v-model="form.Title" type="text" autocomplete="off" name="project-name" class="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
          </div>
        </div>
        <div class="space-y-1 px-4 sm:grid sm:grid-cols-8 sm:gap-4 sm:space-y-0 sm:px-6 sm:py-2">
          <div>
            <label for="project-description" class="block text-sm font-medium text-gray-900 sm:mt-px sm:pt-2">内容</label>
          </div>
          <div class="sm:col-span-7 max-h-96 overflow-auto">
            <div id="editormdid" style="z-index: 9999" v-show="action !== 'view'">
              <textarea style="display:none;" v-model="form.Content"></textarea>
            </div>
            <div id="previewmdid" style="z-index: 9999" v-show="action === 'view'">
              <textarea style="display:none;" v-model="form.Content"></textarea>
            </div>
          </div>
        </div>
      </div>
    </Modal>
    <div id="imageUpload" @click.prevent="upload(false)" style="display: none;"></div>
    <div id="fileUpload" @click.prevent="upload(true)" style="display: none;"></div>
  </div>
</template>

<script>
import Pagination from '../components/Pagination.vue'
import Alert from '../components/Alert.vue'
import Notify from '../components/Notification.vue'
import { pageList, remove, getDetail, edit, add, getCategoryList, uploadFile } from '../api/Article'
import { debounce } from 'lodash'
import Modal from '../components/Modal.vue'
export default {
  name: 'CommentList',
  components: { Alert, Notify, Pagination, Modal },
  data () {
    return {
      alertShow: false,
      modalShow: false,
      detailDialog: false,
      query: {
        PageIndex: 1,
        PageSize: 10,
        keyword: '',
        component_type: 4,
        sort: '-id'
      },
      title: '帖子详情',
      content: '',
      tableData: [],
      total: 0,
      action: 'view',
      form: {
        Id: 0,
        Title: '',
        Content: ''
      },
      editor: null,
      cateList: [],
      fullscreen: ''
    }
  },
  mounted () {
    this.getCateList()
    this.getList()
  },
  methods: {
    upload (isFile = false) {
      const file = document.querySelector(`input[name="editormd-${isFile ? 'file' : 'image'}-file"]`).files[0]
      const upData = new FormData()
      upData.append('formFile', file)
      uploadFile(upData).then(res => {
        if (!res.data.success) {
          this.notifyShow({ title: res.data.message, type: 'error' })
        } else {
          this.notifyShow({ title: '文件上传成功', type: 'success' })
          document.querySelector('.editormd-dialog-container [data-url]').value = 'https://img.huoyuyan.com/' + res.data.url
          document.querySelector('.editormd-dialog-container [data-alt]').value = '附件：' + res.data.name
          document.querySelector('.editormd-enter-btn').click()
        }
      }).catch((err) => {
        console.log(err)
      }).finally(() => {})
    },
    getCateList () {
      getCategoryList().then(res => {
        this.cateList = res.data.data.filter(i => {
          if (this.$store.state.user.admin_group_id >= 3 || this.$store.state.user.admin_group_id == 0) {
            return i.Id !== 5
          } else {
            return true
          }
        })
      })
    },
    getCate (id) {
      const cate = this.cateList.find(i => i.Id === id)
      if (!cate) return '位置分类'
      return cate.Title
    },
    initEditor () {
      window.editormd.emoji = {
        path : "https://www.webpagefx.com/tools/emoji-cheat-sheet/graphics/emojis/",
        ext : ".png"
      }
      this.editor = window.editormd('editormdid', {
        height: 500,
        markdown: this.form.content,
        emoji: true,
        taskList: true,
        tocm: true,
        tex: true,
        flowChart: true,
        sequenceDiagram: true,
        path: '/asset/editor.md/lib/',
        imageUpload : true,
        imageFormats : ["jpg", "jpeg", "gif", "png", "bmp", "webp"],
        imageUploadURL : window.location.protocol + '//api8.huoyuyan.com/api/client/user/market/upload',
        onfullscreen: () => {
          this.fullscreen = 'max-w-full h-screen'
        },
        onfullscreenExit: () => {
          this.fullscreen = ''
        }
      })
      // this.editor.on('onload', () => {
      //   console.log(this.editor.getMarkdown())
      // })
      // editor.setMarkdown(this.form.content)
      // this.editor.on('change', () => {
      //   console.log(this.editor.getMarkdown())
      // })
    },
    preview () {
      window.editormd.markdownToHTML('previewmdid', {
        htmlDecode: "style,script,iframe",
        emoji: true,
        taskList: true,
        tocm: true,
        tex: true,
        flowChart: true,
        sequenceDiagram: true,
      })
    },
    addAction () {
      // this.form = {
      //   Id: 0,
      //   ParentId: 0,
      //   CategoryId: 1,
      //   IsComment: 0,
      //   Title: '',
      //   Content: ''
      // }
      // this.title = '发布帖子'
      // this.action = 'add'
      // this.detailDialog = true
      // this.$nextTick(() => {
      //   this.initEditor()
      // })
      const w = window.open("about:blank");
      w.location.href = "/community/post.html";
    },
    viewAction (row) {
      const w = window.open("about:blank");
      w.location.href = "https://www.huoyuyan.com/community/detail.html?id="+row.Id;
      // this.title = '帖子详情'
      // this.action = 'view'
      // this.getItemDetail(row.Id)
    },
    editAction (row) {
      this.title = '帖子编辑'
      this.action = 'edit'
      this.getItemDetail(row.Id)
    },
    getItemDetail (id) {
      getDetail(id).then(res => {
        this.form = res.data.data
        this.detailDialog = true
        this.$nextTick(() => {
          if (this.action === 'view') {
            this.preview()
          } else {
            this.initEditor()
          }
        })
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    submit () {
      if (this.action === 'edit') {
        this.updateDetail()
      } else {
        this.postData()
      }
    },
    updateDetail () {
      this.form.Content = this.editor.getMarkdown()
      edit(this.form).then(() => {
        this.notifyShow({ title: '修改成功' })
        this.detailDialog = false
        this.getList()
      })
    },
    postData () {
      this.form.Content = this.editor.getMarkdown()
      add(this.form).then(() => {
        this.notifyShow({ title: '发布成功' })
        this.detailDialog = false
        this.getList()
      })
    },
    changePage (page) {
      this.query.PageIndex = page
    },
    notifyShow (msg = { title: '', desc: '', timeout: 3000 }) {
      this.$refs.notify.show(msg)
    },
    refreshData: debounce(
      function () {
        this.getList()
      },
      800
    ),
    getList () {
      this.loading = true
      pageList(this.queryString).then(res => {
        const data = res.data.data
        if (!data.list) data.list = []
        this.tableData = data.list
        this.query.PageIndex = data.PageIndex || data.page || 1
        this.query.PageSize = data.PageSize || data.size || this.query.PageSize
        this.total = data.total || data.Total || 0
        // this.$refs.multipleTable.doLayout()
      }).catch((err) => {
        console.log(err)
      }).finally(() => {
        this.loading = false
      })
    },
    deleteItem (item) {
      this.alertShow = true
      new Promise((resolve, reject) => {
        const instance = this.$refs.alert
        instance.confirm = () => {
          this.alertShow = false
          resolve()
        }
        instance.cancel = () => {
          this.alertShow = false
          reject()
        }
      }).then(() => {
        remove(item.Id).then(() => {
          this.notifyShow({ title: '删除成功' })
          this.getList()
        })
      }).catch(() => { console.log('cancel') })
    }
  },
  watch: {
    query: {
      handler: function () {
        this.refreshData()
      },
      deep: true
    }
  },
  computed: {
    queryString: function () {
      return Object.keys(this.query).filter(key => this.query[key] !== '')
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(this.query[key]))
        .join('&')
    }
  }
}
</script>
